import { render } from "./BlogGridList.vue?vue&type=template&id=1a04c2af"
import script from "./BlogGridList.vue?vue&type=script&lang=js"
export * from "./BlogGridList.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__